export const isProbablyMobile = () => {
    if (typeof navigator === 'undefined') {
        return false;
    }
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isInPhantom = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return /Phantom/i.test(ua) || Boolean(window.phantom?.solana?.isPhantom || window.solana?.isPhantom);
};

export const isInSolflare = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return /Solflare/i.test(ua) || Boolean(window.solflare?.isSolflare);
};

export const isInWalletBrowser = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return isInPhantom()
        || isInSolflare()
        || /Trust/i.test(ua)
        || /Backpack/i.test(ua)
        || /MagicEden|Magic Eden/i.test(ua)
        || Boolean(window.ethereum?.isMetaMask && /Mobile/i.test(ua));
};

export const currentPageUrl = () => (typeof window === 'undefined' ? '' : window.location.href);
export const currentOrigin = () => (typeof window === 'undefined' ? '' : window.location.origin);

export const phantomBrowseUrl = (href = currentPageUrl()) => {
    const url = encodeURIComponent(href);
    const ref = encodeURIComponent(currentOrigin());
    return `https://phantom.app/ul/browse/${url}?ref=${ref}`;
};

export const solflareBrowseUrl = (href = currentPageUrl()) => {
    const url = encodeURIComponent(href);
    const ref = encodeURIComponent(currentOrigin());
    return `https://solflare.com/ul/v1/browse/${url}?ref=${ref}`;
};

export const trustBrowseUrl = (href = currentPageUrl()) => (
    `https://link.trustwallet.com/open_url?coin_id=501&url=${encodeURIComponent(href)}`
);

export const backpackBrowseUrl = (href = currentPageUrl()) => (
    `https://backpack.app/ul/v1/browse/${encodeURIComponent(href)}`
);

export const WALLET_MODAL_OPEN_DELAY_MS = 350;

export const openWalletPicker = ({ select, setVisible }) => {
    if (typeof select === 'function') {
        select(null);
    }
    window.setTimeout(() => setVisible(true), WALLET_MODAL_OPEN_DELAY_MS);
};
